import { render, staticRenderFns } from "./BusinessesForSale.vue?vue&type=template&id=349cd34c&"
import script from "./BusinessesForSale.vue?vue&type=script&lang=ts&"
export * from "./BusinessesForSale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports